import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Paper } from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';

/**
 * Página que se muestra cuando un usuario intenta acceder a una ruta
 * para la cual no tiene permisos.
 */
const Unauthorized = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    // Obtener la ruta de inicio del usuario buscando por patrón 'perfil'
    const usuarioData = window.sessionStorage.getItem('usuario');

    if (usuarioData) {
      try {
        const userData = JSON.parse(usuarioData);
        const menus = userData?.result?.menus || [];

        // Buscar un menú que contenga 'perfil' en la URL (página de inicio)
        const perfilMenu = menus.find(m => m.url && m.url.toLowerCase().includes('perfil'));

        if (perfilMenu) {
          // Redirigir a la página de perfil correspondiente
          navigate(perfilMenu.url, { replace: true });
        } else if (menus.length > 0 && menus[0].url) {
          // Si no hay perfil, usar la primera URL disponible
          navigate(menus[0].url, { replace: true });
        } else {
          // Si no hay menús, cerrar sesión y redirigir a login
          sessionStorage.clear();
          navigate('/', { replace: true });
        }
      } catch (error) {
        // En caso de error, redirigir a login
        navigate('/', { replace: true });
      }
    } else {
      navigate('/', { replace: true });
    }
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      sx={{ backgroundColor: '#f5f5f5' }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 4,
          maxWidth: 500,
          textAlign: 'center',
        }}
      >
        <BlockIcon
          sx={{
            fontSize: 80,
            color: '#d32f2f',
            marginBottom: 2,
          }}
        />
        <Typography variant="h4" gutterBottom>
          Acceso Denegado
        </Typography>
        <Typography variant="body1" color="textSecondary" paragraph>
          No tienes permisos para acceder a esta página.
        </Typography>
        <Typography variant="body2" color="textSecondary" paragraph>
          Si crees que esto es un error, contacta al administrador del sistema.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={handleGoBack}
          sx={{ marginTop: 2 }}
        >
          Volver al Inicio
        </Button>
      </Paper>
    </Box>
  );
};

export default Unauthorized;
